// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WflV","question":"styles_question___gVjE","inputVisibleButton":"styles_inputVisibleButton__8Nuek","note":"styles_note__3LfWL"};